import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.333 17.417v.833a3.755 3.755 0 0 1-3.75 3.75H5.75A3.755 3.755 0 0 1 2 18.25v-5.833a3.755 3.755 0 0 1 3.75-3.75h.833a.417.417 0 0 1 0 .833H5.75a2.92 2.92 0 0 0-2.917 2.917v5.833a2.92 2.92 0 0 0 2.917 2.917h5.833A2.92 2.92 0 0 0 14.5 18.25v-.833a.417.417 0 0 1 .833 0M22 5.75v5.833a3.755 3.755 0 0 1-3.75 3.75h-5.833a3.755 3.755 0 0 1-3.75-3.75V5.75A3.755 3.755 0 0 1 12.417 2h5.833A3.755 3.755 0 0 1 22 5.75m-.833 0a2.92 2.92 0 0 0-2.917-2.917h-5.833A2.92 2.92 0 0 0 9.5 5.75v5.833a2.92 2.92 0 0 0 2.917 2.917h5.833a2.92 2.92 0 0 0 2.917-2.917z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "copy"}) } }